import styled, { keyframes } from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

const sparklesLargeKf = keyframes`
    0% {
        transform: translate(0, 0) scale(1) rotate(0deg);
        opacity: 1;
        animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
    }
    20% {
        transform: translate(2px, -7px) scale(0.75) rotate(45deg);
        opacity: 0.85;
        animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    }
    40%, 60% {
        transform: translate(10px, -7px) scale(0.5) rotate(90deg);
        opacity: 0.55;
        animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
    }
    80% {
        transform: translate(8px, 0px) scale(0.75) rotate(135deg);
        opacity: 0.85;
        animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    }
    100% {
        transform: translate(0, 0) scale(1) rotate(180deg);
        opacity: 1;
    }
`;

const sparklesSmallKf = keyframes`
    0% {
        transform: translate(0, 0) scale(1) rotate(0deg);
        opacity: 0.55;
        animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
    }
    20% {
        transform: translate(-2px, 7px) scale(1.5) rotate(45deg);
        opacity: 0.85;
        animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    }
    40%, 60% {
        transform: translate(-10px, 7px) scale(2) rotate(90deg);
        opacity: 1;
        animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
    }
    80% {
        transform: translate(-8px, 0px) scale(1.5) rotate(135deg);
        opacity: 0.85;
        animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    }
    100% {
        transform: translate(0, 0) scale(1) rotate(180deg);
        opacity: 0.55;
    }
`;

export const AnimatedLargeStar = styled.g`
    transform-origin: 8px 11px;
    animation: ${sparklesLargeKf} 2.4s infinite;
`;

export const AnimatedSmallStar = styled.g`
    transform-origin: 18px 4px;
    animation: ${sparklesSmallKf} 2.4s infinite;
`;

export const SparklesFrame = styled.span`
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
`;

export const SparklesIconShape = styled.span`
    position: absolute;
    top: 10.42%;
    right: 4.17%;
    bottom: 10.42%;
    left: 4.17%;
`;

export const SparklesSvg = styled.svg`
    display: block;
    width: 100%;
    height: 100%;
    overflow: visible;
`;

export const LoadingRow = styled(Flex)`
    align-items: center;
    gap: 8px;
`;
